import { render, staticRenderFns } from "./PetAndProjectComponent.vue?vue&type=template&id=6aa163c2&scoped=true&"
import script from "./PetAndProjectComponent.vue?vue&type=script&lang=js&"
export * from "./PetAndProjectComponent.vue?vue&type=script&lang=js&"
import style0 from "./PetAndProjectComponent.vue?vue&type=style&index=0&id=6aa163c2&lang=scss&scoped=true&"
import style1 from "./PetAndProjectComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa163c2",
  null
  
)

export default component.exports